<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Germinated Seed Bag"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div v-if="detailInfo">
            <p class="detail-title">Details</p>
            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <tr>
                        <td>QR Code</td>
                        <td>{{ qrCode }}</td>
                    </tr>
                    <tr>
                        <td>Progeny</td>
                        <td>{{ detailInfo.progeny.code || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Cross Type</td>
                        <td>{{ (detailInfo.progeny.crossType||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Female Palm</td>
                        <td>{{ femalePalm }}</td>
                    </tr>
                    <tr>
                        <td>Male Palm</td>
                        <td>{{ malePalm }}</td>
                    </tr>
                    <tr>
                        <td>Fresh Seed Bag</td>
                        <td>{{ freshSeedBag }}</td>
                    </tr>
                    
                    <tr>
                        <td class="table-section" colspan="2">Status</td>
                    </tr>
                    <tr>
                        <td>Germinated Seed Status</td>
                        <td>{{ detailInfo.status || "-" }}</td>
                    </tr>

                    <tr>
                        <td class="table-section" colspan="2">Amount</td>
                    </tr>
                    <tr>
                        <td>Total Received</td>
                        <td>{{ detailInfo.totalReceiveAmount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Current Amount</td>
                        <td>{{ detailInfo.currentAmount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Total Germinated</td>
                        <td>{{ detailInfo.totalGerminatedAmount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Total Ungerminated</td>
                        <td>{{ detailInfo.totalUngerminatedAmount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Total Distributed</td>
                        <td>{{ detailInfo.totalDistributeAmount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Total Culled</td>
                        <td>{{ detailInfo.totalCulledAmount || "-" }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { germinatedSeedBagGet } from "@/api/germinated_seed_bag";

export default {
    components: {
        "detail-header": DetailHeader,
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null,
            detailSteps: [
                { name: "Fungicide Treatment", dateKey: "fungicideTreamentDate", employeeKey: "" },
                { name: "Store", dateKey: "storeDate", employeeKey: "storeEmployee" },
                { name: "MC Test", dateKey: "testDate", employeeKey: "testEmployee" },
            ]
        };
    },
    computed: {
        qrCode() {
            return this.detailInfo.qrCode ? `${this.detailInfo?.qrCode?.code}` : "";
        },
        expireDate() {
            if (this.detailInfo.expireDate) {
                let days = this.$_getDaysFromDate(this.detailInfo.expireDate);
                let format_date = this.$_getMyrDateFormat(this.detailInfo.expireDate);
                return `${format_date} (${days})`;
            }
            else return "-";
        },
        femalePalm() {
            return this.arrangePassportFormat(this.detailInfo?.progeny?.maternalPalm?.trial, this.detailInfo?.progeny?.maternalPalm?.trialPalmNumber, this.detailInfo?.progeny);
        },
        malePalm() {
            return this.arrangePassportFormat(this.detailInfo?.progeny?.paternalPalm?.trial, this.detailInfo?.progeny?.paternalPalm?.trialPalmNumber, this.detailInfo?.progeny);
        },
        freshSeedBag() {
            return this.detailInfo?.freshSeedBag?.qrCode?.code || "-";
        },
        steps() {
            return this.detailSteps.map(step => ({
                "name": step.name,
                "description": this.getRecordDateAndUser(this.detailInfo[step.dateKey], this.detailInfo[step.employeeKey]),
                "value": this.getIsHavingRecord(this.detailInfo[step.dateKey])
            }));
        },
        highlightedStep() {
            let lastHighlightedIndex = -1;
            this.steps.forEach((step, index) => {
                if (step.value === true) {
                    lastHighlightedIndex = index;
                }
            });
            return lastHighlightedIndex == -1 ? 0 : lastHighlightedIndex + 1;;
        } 
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        getRecordDateAndUser(recordDate, recordUser) {
            let date = this.$_getMyrDateFormat(recordDate);
            let user = recordUser?.name || "-";
            return `${date} by ${user}`;
        },
        getIsHavingRecord(recordDate) {
            if (recordDate) {
                return true;
            }
            else return false;
        },
        async getDetails() {
            console.log("details", this.infoSidebarId);
            if (this.infoSidebarId) {
                var res = await germinatedSeedBagGet({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        refreshDetailPage() {
            this.getDetails();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    }
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-16) 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/GerminatedSeedSidebar.vue